import {
  Config
} from 'helpers/models';

const mapping = (key, meta) => {
  return {
    type: meta.type,
    field: key,
    eligibleDescription: meta.attributes.field_eligible_hero_description_,
    ineligibleDescription: meta.attributes.field_ineligible_hero_descriptio,
    paymentSuccessMessage: meta.attributes.field_payment_success_message,
    voucherShareMessage: meta.attributes.field_voucher_share_message,
    confirmOrderTitle: meta.attributes.field_confirm_order_title,
    confirmOrderDescription: meta.attributes.field_confirm_order_description,
    advanceSuccessMessage: meta.attributes.field_advance_success_message,
    buyNowBanner: meta.attributes.field_buy_now_banner,
    voucherRedeemText: meta.attributes.field_voucher_redeem_text,
    vouchersUnavailableError: meta.attributes.field_vouchers_unavailable_error,
    outletsUnavailableError: meta.attributes.field_outlets_unavailable_error,
    purchaseHistoryError: meta.attributes.field_purchase_history_error,
    noPastPurchases: meta.attributes.field_no_past_purchases,
    minimumAirtimeBalance: meta.attributes.field_minimum_airtime_balance,
    minimumDataBalance: meta.attributes.field_minimum_data_balance,
    promptHeaderText: meta.attributes.field_prompt_header_text,
    promptBodyText: meta.attributes.field_prompt_body_text,
    miniAppId: meta.attributes.field_mini_app_appid,
    miniAppName: meta.attributes.field_mini_app_name
  };
};

const mapRelationships = (obj, included) => {
  return Object.keys(obj).flatMap((key) => {
    const item = obj[key];

    return included.flatMap((meta) => {

      if (item.data.id === meta.id) {
        return mapping(key, meta);
      }

      if (Array.isArray(item.data)) {
        return item.data.flatMap((itemData) => {
          if (itemData.id === meta.id) {
            return mapping(key, meta);
          }
        return [];
        });
      }
      return [];
    });
  });
};

export const mapConfig = (result) => {
  return result.data
    .map((item) => {
      return {
        attributes: {
          ...item.attributes,
          relationships: mapRelationships(item.relationships, result.included)
        }
      };
    })
    .map((content) => {

      return new Config(content).mapToStandard();
    });
};